/** SAP/list placeholder — not accepted as a real mobile on submit. */
export function sanitizeDriverMobile(v: unknown): string {
  const raw = String(v ?? '').trim();
  if (!raw || /^0+$/.test(raw)) return '';
  return raw;
}

export function isPlaceholderDriverMobile(v: string | undefined): boolean {
  const s = String(v ?? '').trim();
  return !s || /^0+$/.test(s);
}
